import React, { createContext, useContext, ReactNode } from "react";

export interface IContentWizardContext {
  activeStep: number;
  setActiveStep: (step: number) => void;
  goNext: () => void;
  goPrevious: () => void;
  direction: "left" | "right";
  totalSteps: number;
}

const ContentWizardContext = createContext<IContentWizardContext | undefined>(
  undefined
);

export interface IContentWizardContextProvider {
  children: ReactNode;
  value: IContentWizardContext;
}

export const ContentWizardContextProvider: React.FC<
  IContentWizardContextProvider
> = ({ children, value }) => {
  return (
    <ContentWizardContext.Provider value={value}>
      {children}
    </ContentWizardContext.Provider>
  );
};

export const useContentWizardContext = (): IContentWizardContext => {
  const context = useContext(ContentWizardContext);

  if (context === undefined) {
    throw new Error(
      "useContentWizardContext must be used within a ContentWizardContextProvider"
    );
  }

  return context;
};
